import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import "./../../Style/SalesDetailStyle.scss";
import CircularProgress from "@mui/material/CircularProgress";
import {
  deleteAlert,
  errorAlert,
  handleSuccess,
  updateAlert,
} from "../../Components/Alerts";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import jwtDecode from "jwt-decode";
import { AiFillAppstore } from "react-icons/ai";
import { FaTicketAlt, FaEnvelope } from "react-icons/fa";
import { Paper, TextareaAutosize } from "@mui/material";
import "jspdf-autotable";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import PrintContent from "../../Print/PrintContent";
import { MdEdit } from "react-icons/md";
import InsertClient from "../Clients/InsertClients";
// import InsertArticle from "../Article/InsertArticle";
import ItemFormModal from "../../NewCRUD/ArticleCRUD/ArticleModal";
import InputAdornment from "@mui/material/InputAdornment";
import DataGridWithActions from "../../Components/DataGridWithActions";
import Autocomplete from "@mui/material/Autocomplete";
import ButtonGroup from "@mui/material/ButtonGroup";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import {
  ElementsParagraph,
  TitleElements,
} from "../../Components/HeadersCRUD-s";
import {
  AddLinkButton,
  LinkAndClickButton,
  AddElementsButton,
} from "../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../Components/HeaderPaperComponent";
// import { saveAs } from "file-saver";
import MuiButton from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { detailsData, returnGridHeader } from "./ReturnFromClientGridHeader";
import CancelModal from "../../Components/CancelModal";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";
import AccountsAutocompleteEdit from "../../Components/AccountsAutocompleteEdit";
import ArticleAutocompleteEdit from "../../Components/ArticleAutocompleteEdit";
import ArticleAutocompleteInsert from "../../Components/ArticleAutocompleteInsert";

export default function KthimiMallitNgaKlienti() {
  const TranscationData = [
    {
      id: 1,
      type: "Vendore",
    },
    {
      id: 2,
      type: "Eksport",
    },
    {
      id: 3,
      type: "Sherbime jashtë vendit",
    },
    {
      id: 4,
      type: "Ngarkesa Kundert",
    },
  ];
  const { fiscalYear } = useContext(FiscalYearContext);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDare] = useState("");

  useEffect(() => {
    setMinDate(`${fiscalYear}-01-01`);
    setMaxDare(`${fiscalYear}-12-31`);
  }, [fiscalYear]);

  const [lang, setLang] = useState("sq");

  const headers = authHeader();
  const [showDetails, setShowDetails] = useState(true);

  const [hasClientBranch, setHasClientBranch] = useState(false);
  const [clientBranch, setClientBranch] = useState([]);
  const [clientBranchID, setClientBranchID] = useState("");

  const [hasElectronicSeal, setHasElectronicSeal] = useState(null);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const [changeButton, setChangeButton] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [logedEmail, setLogedEmail] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      setLogedEmail(decodedToken.email);
    }
  }, []);

  const [data, setData] = useState([]);
  const [detailLine, setDetailLine] = useState([]); //i mban rreshtat e te dhenave detale
  const [formData, setFormData] = useState({
    TransactionID: "",
    InvoiceNr: "",
    Date: "",
    PayDate: "",
    ActionType: "",
    AccountIDSpare: "",
    ClientBranchID: "",
    AccountID: "",
    ClientID: "",
    Amount0: 0,
    Amount8: 0,
    Amount18: 0,
    VAT8: "",
    VAT18: "",
    Total: "",
    PaymentOptions: "",
    TransactionType: "",
    Coment: "",
    ModifiedByUser: "",
    CompanyUnitID: "",
  });

  const [formDetailData, setFormDetailData] = useState({
    HistoryID: "",
    ArticleID: "",
    QtyInput: "",
    DiscountPercent: "",
    PriceBeforeDiscount: "",
    Total: "",
    PriceWithVAT: "",
    PriceWithoutVAT: "",
    ModifiedByUser: "",
    InvoiceNr: "",
    PaymentOptions: "",
  });

  //Per insertimin ne Article History
  const [articleID, setArticleID] = useState("");
  const [qtyInput, setQtyInput] = useState(0);
  const [insertpriceWithoutVAT, setInsertPriceWithoutVAT] = useState(0);
  const [insertPriceWithVAT, setInsertPriceWithVAT] = useState(0);
  const [insertTotal, setInsertTotal] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [vatRates, setVATRates] = useState("");
  const [transactionsType, setTransactionType] = useState("");

  // let number = 1;

  const [showEditModal, setShowEditModal] = useState(false);
  // const [searchTerm, setSearchTerm] = useState("");
  //   const [clients, setClients] = useState([]);
  // const [expence, setExpence] = useState([]);
  const [cashRegister, setCashRegister] = useState([]);

  const [companyName, setCompanyName] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyID, setcompanyID] = useState("");

  //   const [articles, setArticles] = useState([]);
  // const [filteredArticles, setFilteredArticles] = useState([]);

  const [valuedetails, setValueDetails] = useState([]);
  const [clientDetails, setClientDetails] = useState([]);

  // Te dhenat per printim
  const [headerData, setHeaderData] = useState([]);
  const [companiesData, setCompaniesData] = useState([]);
  // const [logoPath, setLogoPath] = useState("");

  const [articlePrintDetails, setArticlePrintDetails] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);

  // keto konstante sherbejn per ta mbajtur gjendjen e formave nese jane hide ose jo
  const [showEditForm, setShowEditForm] = useState(false);
  const [showInserForm, setShowInsertForm] = useState(true);

  const [discountAmount, setDiscountAmount] = useState(0);
  const [perqindjaZbritjes, setPerqindjaZbritjes] = useState(0);
  const [totalWithDiscountAmount, setTotalWithDiscountAmount] = useState(0);
  const [tempPriceWithVAT, setTempPriceWithVAT] = useState(0);

  // kodi per dergimin e emailit
  const [clientEmail, setClientEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [uInvoiceNr, setUInvoiceNr] = useState("");
  const [showEmailConfirmation, setShowEmailConfirmation] = useState(false);

  useEffect(() => {
    if (TranscationData == 2 || TranscationData == 3) {
      setVATRates(0);
    }
  });

  useEffect(() => {
    if (formData.InvoiceNr) {
      let Sb = lang == "en" ? "Invoice number:" : "Fatura me numër:";
      // setSubject(`${Sb} ${formData.InvoiceNr}`);
      setSubject(`${Sb} CND-${fiscalYear}-${formData.InvoiceNr}`);
    }
  }, [formData.InvoiceNr, lang, fiscalYear]);

  const [link, setLink] = useState("");

  const [sendingEmail, setSendingEmail] = useState(false);

  const sendEmail = (event, lang) => {
    event.preventDefault();
    setSendingEmail(true); // Ndryshoni gjendjen e progresit në fillim të dërgimit të emailit

    if (clientEmail === "" || clientEmail == null) {
      errorAlert(
        "Emaili nuk mund te dergohet, sepse klienti nuk ka email te regjistruar",
      );
      setSendingEmail(false);
      return;
    }
    if (uInvoiceNr === "" || uInvoiceNr == null) {
      errorAlert(
        "Fatura nuk mund te dergohet sepse, ende nuk e keni ruajtur faturen ne databaz",
      );
      setSendingEmail(false);
      return;
    }

    // Përdor parametrin 'lang' për gjuhën
    const newInvoiceURL = encodeURI(
      `http://app.acctree.net/invoice?invoiceNR=${uInvoiceNr}&lang=${lang}`,
    );
    // const newInvoiceURL = encodeURI(`http://localhost:3000/invoice?invoiceNR=${uInvoiceNr}&lang=${lang}`);
    // Përmbajtja e emailit për shqip
    const emailBodySQ = `Të nderuar,
    
        Dëshirojmë t'ju njoftojmë se fatura elektronike është krijuar me sukses dhe është gati për shkarkim. Për të marrë faturën tuaj, ju lutem klikoni në linkun e mëposhtëm: ${newInvoiceURL}.
    
        Ju lutëm të kryeni pagesën e faturës në njëren nga llogaritë e ${companyName} që janë specifikuar në faturë.
    
        Për çdo pyetje apo ndihmë shtesë, mos ngurroni të na kontaktoni në adresen elektronike: ${companyEmail}
    
        Me respekt,
        ${companyName}`;

    // Përmbajtja e emailit për anglisht
    const emailBodyEN = `Dear Sir/Madam,
    
        We would like to inform you that the electronic invoice has been successfully created and is ready for download. To access your invoice, please click on the following link: ${newInvoiceURL}.
    
        Please make the payment to one of ${companyName}'s bank accounts specified in the invoice.
    
        For any questions or further assistance, feel free to contact us at: ${companyEmail}
    
        Best regards,
        ${companyName}`;

    // Zgjidh përmbajtjen e emailit sipas gjuhës
    const emailBody = lang === "en" ? emailBodyEN : emailBodySQ;

    const data = {
      To: clientEmail,
      Subject: subject,
      Body: emailBody, // Përdor emailBody bazuar në gjuhën e zgjedhur
    };

    axios
      .post(ApiLink.API_URL + "Gmail", data, { headers })
      .then(() => {
        handleSuccess("Email sent successfully");
        setShowEmailConfirmation(false);
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          errorAlert("An unknown error occurred while processing the request.");
          setSendingEmail(false);
        }
      })
      .finally(() => {
        setSendingEmail(false); // Përfundimi i dërgimit të emailit, ndryshoni gjendjen e progresit
      });
  };

  // ky kod i ndryshon gjendjet e formave

  const handleOpenForm2 = () => {
    setShowInsertForm(true);
    setShowEditForm(false); // I fsheh formën e parë
    setArticleID();
    setQtyInput(0);
    setInsertPriceWithoutVAT(0);
    setInsertPriceWithVAT(0);
    setInsertTotal(0);
  };
  const handleOpenForm1 = () => {
    setShowInsertForm(false);
    setShowEditForm(true); // I fsheh formën e parë
  };

  const clearEdit = () => {
    setFormDetailData({
      HistoryID: "",
      ArticleID: "",
      QtyInput: 0,
      DiscountPercent: 0,
      PriceBeforeDiscount: 0,
      PriceWithVAT: 0,
      PriceWithoutVAT: 0,
      setFormDetailData: 0,
    });

    clearLine();
    handleOpenForm2();
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "ReturnFromClient", {
        headers,
        params: { fiscalYear: fiscalYear },
      });
      setData(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchDetailLineData = async (invoicenr) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ReturnFromClient/returnDetails",
        { headers, params: { invNumber: invoicenr, fiscalYear: fiscalYear } },
      );
      setDetailLine(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  //   const fetchArticles = async () => {
  //     try {
  //       const response = await axios.get(ApiLink.API_URL + "Article", {
  //         headers,
  //       });
  //       setArticles(response.data);
  //     } catch (error) {
  //       errorAlert("Gabim në kërkesë:", error);

  //       if (
  //         error.response &&
  //         error.response.data &&
  //         error.response.data.errorMessage
  //       ) {
  //         errorAlert(
  //           `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
  //         );
  //       } else if (error.message) {
  //         errorAlert(`Gabim: ${error.message}`);
  //       } else {
  //         errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //       }
  //     }
  //   };

  const fetchHeaderData = async (number) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ReturnFromClient/GetPrintHeaderDetails",
        {
          headers,
          params: {
            invNumber: number,
            actionType: "CND",
            fiscalYear: fiscalYear,
          },
        },
      );
      setHeaderData(response.data);
      setUInvoiceNr(response.data[0].TransactionUID);
      setLink(
        encodeURI(
          `http://app.acctree.net/invoice?invoiceNR=${response.data[0].TransactionUID}`,
        ),
      );
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchBanksAccount = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/BankDetails",
        { headers },
      );
      setBankAccounts(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchCompaniesData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Companies/getCompanyDetails",
        { headers },
      );
      setCompaniesData(response.data);
      setCompanyName(response.data[0].CompanyName);
      setCompanyEmail(response.data[0].Email);
      setcompanyID(response.data[0].CompanyID);
      setHasElectronicSeal(response.data[0].ElectronicSeal);
      // setLogoPath(ApiLink.PHOTO_URL + response.data[0].CompanyLogo);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchArticleDataPrint = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/GetArticleDetailsForPrint",
        {
          headers,
          params: {
            invNumber: formData.InvoiceNr,
            actionType: "CND",
            fiscalYear: fiscalYear,
          },
        },
      );
      setArticlePrintDetails(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchvaluedetails = async (number) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ReturnFromClient/getvaluedetails",
        { headers, params: { invNumber: number, fiscalYear: fiscalYear } },
      );
      setValueDetails(response.data);
      setDiscountAmount(
        response.data[0].DiscountAmount !== null
          ? response.data[0].DiscountAmount
          : 0,
      );
      setTotalWithDiscountAmount(
        response.data[0].Total + response.data[0].DiscountAmount,
      );
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchClientBranch = async (clientID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ClientBranches/clientBranchFilterByAccountID",
        { headers, params: { accountID: clientID } },
      );
      setClientBranch(response.data);
      if (response.data.length > 0) {
        setHasClientBranch(true);
      } else {
        setHasClientBranch(false);
        setFormData((prevState) => ({
          ...prevState,
          ClientBranchID: "",
        }));
        setClientBranchID("");
      }
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë");
      }
    }
  };

  const handleNewSubmit = (event) => {
    event.preventDefault();
    if (!articleID) {
      errorAlert("Ju lutem plotësoni artikullin");
      return;
    }
    // Shtoni kontrollet këtu
    if (isNaN(qtyInput)) {
      errorAlert("Sasia e produkteve (qtyInput) duhet të jetë një numër.");
      return;
    }
    if (isNaN(insertpriceWithoutVAT)) {
      errorAlert("Çmimi pa TVSH (priceWithoutVAT) duhet të jetë një numër.");
      return;
    }
    if (isNaN(insertPriceWithVAT)) {
      errorAlert("Çmimi me TVSH (priceWithVAT) duhet të jetë një numër.");
      return;
    }
    if (isNaN(insertTotal)) {
      errorAlert("Totali duhet të jetë një numër.");
      return;
    }

    const stateDate = {
      InvoiceNr: formData.InvoiceNr,
      Date: formData.Date,
      ArticleID: articleID,
      QtyInput: qtyInput,
      DiscountPercent: discountPercent,
      PriceBeforeDiscount: tempPriceWithVAT,
      PriceWithoutVAT: insertpriceWithoutVAT,
      PriceWithVAT: insertPriceWithVAT,
      CreatedByUser: logedEmail,
      SupplierID: formData.AccountID,
    };
    axios
      .post(ApiLink.API_URL + "ReturnFromClient/createnewline", stateDate, {
        headers,
        params: { vatRates: vatRates },
      })
      .then(() => {
        // handleSuccess("Detail  Added Successfully");
        setQtyInput(0);
        setInsertPriceWithoutVAT(0);
        setInsertPriceWithVAT(0);
        setInsertTotal(0);
        setArticleID();
        fetchDetailLineData(formData.InvoiceNr);
        fetchData();
        fetchvaluedetails(formData.InvoiceNr);
        fetchHeaderData(formData.InvoiceNr);
        fetchArticleDataPrint();
        // setArticlesName("");
        setDiscountPercent(0);
        setTempPriceWithVAT(0);
        setField(null);
      })
      .catch((error) => {
        // console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          errorAlert("An unknown error occurred while processing the request.");
        }
      });
  };

  const clearLine = () => {
    setQtyInput(0);
    setInsertPriceWithoutVAT(0);
    setInsertPriceWithVAT(0);
    setInsertTotal(0);
    setArticleID();
    fetchDetailLineData(formData.InvoiceNr);
    fetchData();
    fetchvaluedetails(formData.InvoiceNr);
    fetchHeaderData(formData.InvoiceNr);
    fetchArticleDataPrint();
    // setArticlesName("");
  };

  // Kodi per fshirjen e nje elementi ne databaz
  const handleDelete = async (deleteItemId) => {
    try {
      // const response =
      await axios.delete(
        ApiLink.API_URL + "ReturnFromClient" + `/${deleteItemId}`,
        { headers },
      );
      deleteAlert("Fatura u fshi me sukses");
      fetchData();
    } catch (error) {
      deleteAlert("Deshtoj fshirja e fatures");
    }
  };

  const handleDeleteDetailLine = async (deleteItemIdDetail) => {
    try {
      // const response =
      await axios.delete(
        ApiLink.API_URL + "ReturnFromClient/oneline" + `/${deleteItemIdDetail}`,
        {
          headers,
          params: {
            email: logedEmail,
            invoiceNR: formData.InvoiceNr,
            fiscalYear: fiscalYear,
          },
        },
      );
      deleteAlert("Linja u fshi me sukses");
      fetchArticleDataPrint();
      fetchData();
      fetchDetailLineData(formData.InvoiceNr);
      fetchvaluedetails(formData.InvoiceNr);
      fetchHeaderData(formData.InvoiceNr);
      handleOpenForm2();
    } catch (error) {
      deleteAlert("Deshtoi fshirja e linjes");
    }
  };

  // Kodi per shfaqjen e formes per editimin e te dhenave ne databaz
  const handleEdit = (item) => {
    fetchDetailLineData(item.InvoiceNr);
    fetchHeaderData(item.InvoiceNr);
    fetchvaluedetails(item.InvoiceNr);
    setTransactionType(item.TransactionType);
    // fetchClientsDetails(item.AccountID);
    fetchCompaniesData();
    if (
      item.ClientBranchID != null ||
      item.ClientBranchID != undefined ||
      item.ClientBranchID > 0
    ) {
      setHasClientBranch(true);
      fetchClientBranch(item.AccountID);
      setClientBranchID(item.ClientBranchID);
    } else if (
      item.ClientBranchID == null ||
      item.ClientBranchID == undefined ||
      item.ClientBranchID == 0
    ) {
      fetchClientBranch(item.AccountID);
    } else {
      setHasClientBranch(false);
      setClientBranchID("");
    }

    setFormData({
      TransactionID: item.TransactionID,
      InvoiceNr: item.InvoiceNr,
      Date: item.Date,
      PayDate: item.PayDate,
      ActionType: item.ActionType,
      // AccountID: item.AccountID,
      ClientBranchID: item.ClientBranchID,
      AccountID: item.AccountID,
      PaymentOptions: item.PaymentOptions,
      TransactionType: item.TransactionType,
      CompanyUnitID: item.CompanyUnitID,
      Coment: item.Comment,
      ModifiedByUser: logedEmail,
    });
    setShowEditModal(true);
    setShowDetails(false);
    handleOpenForm2();
  };

  const handleEditDetails = (item) => {
    handleOpenForm1();
    fetchArticlesSalesPrice(item.ArticleID, "getVat");
    setFormDetailData({
      HistoryID: item.HistoryID,
      ArticleID: item.ArticleID,
      QtyInput: item.QtyInput,
      DiscountPercent: item.DiscountPercent,
      PriceBeforeDiscount: item.PriceBeforeDiscount,
      Total: item.Total,
      PriceWithVAT: item.PriceWithVAT,
      PriceWithoutVAT: item.PriceWithoutVAT,
      ModifiedByUser: logedEmail,
      InvoiceNr: formData.InvoiceNr,
      PaymentOptions: formData.PaymentOptions,
    });
  };

  // Kodi per ruajtjen e te dhenave pas editimint
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    setChangeButton(true);
  };
  //Dergimi i kerkeses per editimin e te dhenave ne backend
  const handleSubmit = (event) => {
    event.preventDefault();
    if (
      formData.PaymentOptions != 0 &&
      (formData.PayDate == "" || formData.PayDate == null)
    ) {
      errorAlert("Please fill payment date");
      return;
    }
    axios
      .put(ApiLink.API_URL + "ReturnFromClient", formData, { headers })
      .then((response) => {
        // console.log(response.data);
        // setShowEditModal(false);
        // Close the edit modal
        fetchData();
        updateAlert("Te dhenat u ndryshuan me sukses");
        fetchArticleDataPrint();
        fetchHeaderData(formData.InvoiceNr);
        setChangeButton(false);
      })
      .catch((error) => {
        // alert("Failed to update State");
        errorAlert("Te dhenat nuk u ndryshuan");
      });
  };

  // Kodi per ruajtjen e te dhenave pas editimint
  const handleInputChangeDetail = (event) => {
    const { name, value } = event.target;
    setFormDetailData({ ...formDetailData, [name]: value });
  };

  const handleSubmitDetailLine = (event) => {
    event.preventDefault();
    axios
      .put(
        ApiLink.API_URL + "ReturnFromClient/updatedetailsArticle",
        formDetailData,
        { headers, params: { vatRates: vatRates, fiscalYear: fiscalYear } },
      )
      .then((response) => {
        fetchDetailLineData(formData.InvoiceNr);
        fetchvaluedetails(formData.InvoiceNr);
        updateAlert("Linja u ndryshua me sukses");
        fetchArticleDataPrint();
        fetchHeaderData(formData.InvoiceNr);
        fetchData();
        handleOpenForm2();
      })
      .catch((error) => {
        // console.log(error);
        errorAlert("Linja nuk u ndryshua");
      });
  };

  const calculatePercent = (value) => {
    setPerqindjaZbritjes((value / totalWithDiscountAmount) * 100);
  };

  const fetchPaymentType = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/paymenttype",
        { headers },
      );
      setCashRegister(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë");
      }
    }
  };

  const fetchClientsDetails = async (accID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByID",
        { headers, params: { id: accID } },
      );
      setClientDetails(response.data);
      setClientEmail(response.data[0].Email);
    } catch (error) {
      // errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        // errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë.");
      }
    }
  };
  //   const fetchClients = async () => {
  //     try {
  //       const response = await axios.get(
  //         ApiLink.API_URL + "Accounts/accountByLedger",
  //         { headers, params: { ledger: 105 } },
  //       );
  //       setClients(response.data);
  //     } catch (error) {
  //       errorAlert("Gabim në kërkesë:", error);
  //       if (
  //         error.response &&
  //         error.response.data &&
  //         error.response.data.errorMessage
  //       ) {
  //         errorAlert(
  //           `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
  //         );
  //       } else if (error.message) {
  //         errorAlert(`Gabim: ${error.message} `);
  //       } else {
  //         errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //       }
  //     }
  //   };

  // ky kod sherben per ta bere aplikimin e zbritjes ne qmimin e pergjithshem ne shum
  const constUpdateDiscountAmount = (event) => {
    event.preventDefault();
    axios
      .put(
        `${ApiLink.API_URL}ReturnFromClient/aplikoZbritjen?companyID=${companyID}&invoiceNr=${formData.InvoiceNr}&percent=${perqindjaZbritjes}&fiscalYear=${fiscalYear}`,
        {},
        { headers },
      )
      .then((response) => {
        fetchvaluedetails(formData.InvoiceNr);
        fetchArticleDataPrint();
        fetchHeaderData(formData.InvoiceNr);
        fetchData();
        fetchDetailLineData(formData.InvoiceNr);
      })
      .catch((error) => {
        // console.log(error);
        errorAlert(error);
      });
  };

  const fetchArticlesSalesPrice = async (articleID, form) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/GetSalesPrice",
        { headers, params: { articleID: articleID } },
      );
      const salesPriceData = response.data; // Merr të dy vlerat e "SalesPrice" dhe "VATRates" nga përgjigja

      if (form == "edit") {
        const calculatedValue =
          (parseFloat(response.data.SalesPrice) * 100) /
          (100 + response.data.SalesPrice);
        // setInsertPriceWithoutVAT(calculatedValue.toFixed(2));
        setVATRates(response.data.VATRates);

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: response.data.SalesPrice,
          PriceWithoutVAT: calculatedValue,
          DiscountPercent: 0,
          //   QtyInput: 1,
          PriceBeforeDiscount: response.data.SalesPrice,
          //   Total: 1 * response.data.SalesPrice,
          Total: formDetailData.QtyInput * response.data.SalesPrice,
        }));
      } else if (form == "getVat") {
        setVATRates(response.data.VATRates);
      } else {
        setInsertPriceWithVAT(salesPriceData.SalesPrice);
        setTempPriceWithVAT(salesPriceData.SalesPrice);
        setVATRates(response.data.VATRates);
        setQtyInput(1);
        setInsertTotal(1 * salesPriceData.SalesPrice);
        // Kalkulimi i vlerës pa TVSH dhe vendosja e saj tek PriceWithoutVAT
        const calculatedValue =
          (parseFloat(salesPriceData.SalesPrice) * 100) /
          (100 + salesPriceData.VATRates);
        setInsertPriceWithoutVAT(calculatedValue.toFixed(2));
        // setTotal(1 * salesPriceData.SalesPrice);
      }
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const handleCalculatePriceWithVAT = async (type) => {
    try {
      if (isNaN(insertpriceWithoutVAT)) {
        throw new Error(
          "Çmimi pa TVSH (priceWithoutVAT) duhet të jetë një numër.",
        );
      }

      if (isNaN(qtyInput)) {
        throw new Error(
          "Sasia e produkteve (qtyInput) duhet të jetë një numër.",
        );
      }
      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const vat =
          Number(formDetailData.PriceWithoutVAT) * (Number(vatRates) / 100);
        const calculatedPriceWithVAT =
          Number(formDetailData.PriceWithoutVAT) + vat;
        const total = Number(formDetailData.QtyInput) * calculatedPriceWithVAT;

        setTempPriceWithVAT(
          Number(calculatedPriceWithVAT) /
            (1 - Number(formDetailData.DiscountPercent) / 100),
        );

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: calculatedPriceWithVAT,
          Total: total,
          PriceBeforeDiscount: tempPriceWithVAT,
        }));
      } else {
        const vat = Number(insertpriceWithoutVAT) * (Number(vatRates) / 100);
        const calculatedPriceWithVAT = Number(insertpriceWithoutVAT) + vat;
        const total = Number(qtyInput) * calculatedPriceWithVAT;
        // Veprimet specifike për insert të ri
        setInsertPriceWithVAT(calculatedPriceWithVAT);
        setInsertTotal(total);

        setTempPriceWithVAT(
          Number(calculatedPriceWithVAT) / (1 - Number(discountPercent) / 100),
        );
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };

  const handleCalculatePriceWithoutVAT = async (type) => {
    try {
      if (isNaN(insertPriceWithVAT)) {
        throw new Error(
          "Çmimi me TVSH (priceWithVAT) duhet të jetë një numër.",
        );
      }

      if (isNaN(qtyInput)) {
        throw new Error(
          "Sasia e produkteve (qtyInput) duhet të jetë një numër.",
        );
      }

      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const calculatedPriceWithoutVAT =
          (Number(formDetailData.PriceWithVAT) * 100) /
          (100 + Number(vatRates));
        const total =
          Number(formDetailData.QtyInput) * Number(formDetailData.PriceWithVAT);
        setTempPriceWithVAT(
          Number(formDetailData.PriceWithVAT) /
            (1 - Number(formDetailData.DiscountPercent) / 100),
        );

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
          Total: total,
          PriceBeforeDiscount: tempPriceWithVAT,
        }));
      } else {
        setTempPriceWithVAT(
          Number(insertPriceWithVAT) / (1 - Number(discountPercent) / 100),
        );

        // Veprimet specifike për shtim të ri
        const calculatedPriceWithoutVAT =
          (Number(insertPriceWithVAT) * 100) / (100 + Number(vatRates));
        const total = Number(qtyInput) * Number(insertPriceWithVAT);

        setInsertPriceWithoutVAT(calculatedPriceWithoutVAT);
        setInsertTotal(total);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };

  const handleCalculatePrices = async (type) => {
    try {
      if (isNaN(qtyInput)) {
        throw new Error(
          "Sasia e produkteve (qtyInput) duhet të jetë një numër.",
        );
      }

      if (isNaN(insertTotal)) {
        throw new Error("Totali duhet të jetë një numër.");
      }
      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const priceWithVAT =
          Number(formDetailData.Total) / Number(formDetailData.QtyInput);
        const calculatedPriceWithoutVAT =
          (priceWithVAT * 100) / (100 + Number(vatRates));
        // const calculatedPriceWithoutVAT = formDetailData.PriceWithVAT * 100 / (100 + Number(vatRates));
        const tempPriceWithVATEdit =
          Number(priceWithVAT) /
          (1 - Number(formDetailData.DiscountPercent) / 100.0);
        // setTempPriceWithVAT(Number(formDetailData.PriceWithVAT) / (1 - (Number(formDetailData.DiscountPercent) / 100)))

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: priceWithVAT,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
          PriceBeforeDiscount: tempPriceWithVATEdit,
        }));
      } else {
        // Veprimet specifike për shtim të ri
        const priceWithVAT = Number(insertTotal) / Number(qtyInput);
        const calculatedPriceWithoutVAT =
          (priceWithVAT * 100) / (100 + Number(vatRates));

        setTempPriceWithVAT(
          Number(priceWithVAT) / (1 - Number(discountPercent) / 100),
        );

        setInsertPriceWithoutVAT(calculatedPriceWithoutVAT);
        setInsertPriceWithVAT(priceWithVAT);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };

  const handleCalculatePriceWithRabat = async (type) => {
    try {
      if (isNaN(discountPercent)) {
        throw new Error("% e rabatit (Rabati) duhet të jetë një numër.");
      }

      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        setTempPriceWithVAT(formDetailData.PriceBeforeDiscount);

        const vleraZbritjes =
          tempPriceWithVAT * (formDetailData.DiscountPercent / 100);
        const priceWithVATRabat =
          Number(tempPriceWithVAT) - Number(vleraZbritjes);

        const calculatedPriceWithoutVAT =
          (Number(priceWithVATRabat) * 100) / (100 + Number(vatRates));
        const total =
          Number(formDetailData.QtyInput) * Number(priceWithVATRabat);

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
          PriceWithVAT: priceWithVATRabat,
          Total: total,
          PriceBeforeDiscount: tempPriceWithVAT,
        }));
      } else {
        // Veprimet specifike për shtim të ri
        const vleraZbritjes = tempPriceWithVAT * (discountPercent / 100);
        const priceWithVATRabat =
          Number(tempPriceWithVAT) - Number(vleraZbritjes);

        const calculatedPriceWithoutVAT =
          (Number(priceWithVATRabat) * 100) / (100 + Number(vatRates));
        const total = Number(qtyInput) * Number(priceWithVATRabat);

        setInsertPriceWithoutVAT(calculatedPriceWithoutVAT);
        setInsertPriceWithVAT(priceWithVATRabat);
        setInsertTotal(total);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };

  //Select list for Clients
  //   const handleAutocompleteChangeClients = (event, value) => {
  //     if (value) {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         AccountID: value.AccountID,
  //         // ClientBranchID: clientBranchID,
  //       }));
  //       fetchClientBranch(value.AccountID);
  //       setChangeButton(true);
  //     } else {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         AccountID: "",
  //         // ClientBranchID: ""
  //       }));
  //     }
  //   };

  //   const defaultPropsClients = {
  //     options: clients,
  //     getOptionLabel: (option) =>
  //       `${option.IdentificationNumber} - ${option.AccountName}` || "",
  //     renderOption: (props, option) => (
  //       <>
  //         <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //           <span>
  //             {option.IdentificationNumber}
  //             <br />
  //             {option.AccountName}
  //           </span>
  //         </li>
  //       </>
  //     ),
  //   };
  ////////////////////////////////

  //Select list for Clients
  const handleAutocompleteChangeClientBranch = (event, value) => {
    if (value) {
      setClientBranchID(value.ClientBranchID);
      setFormData((prevState) => ({
        ...prevState,
        ClientBranchID: value.ClientBranchID,
      }));
      setChangeButton(true);
    } else {
      setClientBranchID("");
      setFormData((prevState) => ({
        ...prevState,
        ClientBranchID: "",
      }));
    }
  };

  const defaultPropsClientBranch = {
    options: clientBranch,
    getOptionLabel: (option) =>
      `${option.ClientBranchName} - ${option.ClientBranchAddress}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            <b> {option.ClientBranchName}</b>
            <br />
            {option.ClientBranchAddress}
          </span>
        </li>
      </>
    ),
  };
  ////////////////////////////////

  ////Select list tek Artikulli per editim
  //   const handleAutocompleteChangeArticleEdit = (event, value) => {
  //     if (value) {
  //       setFormDetailData((prevState) => ({
  //         ...prevState,
  //         ArticleID: value.ArticleID,
  //       }));
  //       fetchArticlesSalesPrice(value.ArticleID, "edit");
  //     } else {
  //       setFormDetailData((prevState) => ({
  //         ...prevState,
  //         ArticleID: "",
  //       }));
  //     }
  //   };

  //   const defaultPropsArticleEdit = {
  //     options: articles,
  //     getOptionLabel: (option) =>
  //       `${option.Barcode} - ${option.ArticleName}` || "",
  //     renderOption: (props, option) => (
  //       <>
  //         <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //           <span>
  //             {option.Barcode}
  //             <br />
  //             {option.ArticleName}
  //           </span>
  //           <label style={{ marginLeft: "auto", fontWeight: "bold" }}>
  //             {/* {option.SalesPrice}€ */}
  //             {option.SalesPrice !== null && option.SalesPrice !== 0
  //               ? option.SalesPrice.toLocaleString("en-US", {
  //                   minimumFractionDigits: 2,
  //                 })
  //               : "0.00"}
  //             €
  //           </label>
  //           {/* <button
  //                         onClick={(e) => {
  //                             e.stopPropagation();
  //                             // handleButtonClick(option);
  //                         }}
  //                         style={{ marginLeft: 'auto' }}
  //                     >
  //                         click me
  //                     </button> */}
  //         </li>
  //       </>
  //     ),
  //   };

  //Pjesa per select input field Article
  const [isArticleModalOpen, setIsArticleModalOpen] = useState(false);
  const [field, setField] = useState(null);
  //   const handleAutocompleteChangeArticle = (event, value) => {
  //     if (value && value.ArticleID) {
  //       setArticleID(value.ArticleID);
  //       fetchArticlesSalesPrice(value.ArticleID);
  //       setField(value);
  //     } else {
  //       // Në rast se vlera është pastruar
  //       setArticleID(""); // Vendos vlerën e ArticleID në null
  //       setField(null);
  //     }
  //   };

  //   const defaultPropsArticle = {
  //     options: articles,
  //     getOptionLabel: (option) =>
  //       `${option.Barcode} - ${option.ArticleName}` || "",
  //     renderOption: (props, option) => (
  //       <>
  //         <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //           <span>
  //             {option.Barcode}
  //             <br />
  //             {option.ArticleName}
  //           </span>
  //           <label style={{ marginLeft: "auto", fontWeight: "bold" }}>
  //             {/* {option.SalesPrice}€ */}
  //             {option.SalesPrice !== null && option.SalesPrice !== 0
  //               ? option.SalesPrice.toLocaleString("en-US", {
  //                   minimumFractionDigits: 2,
  //                 })
  //               : "0.00"}
  //             €
  //           </label>
  //           {/* <button
  //                         onClick={(e) => {
  //                             e.stopPropagation();
  //                             // handleButtonClick(option);
  //                         }}
  //                         style={{ marginLeft: 'auto' }}
  //                     >
  //                         click me
  //                     </button> */}
  //         </li>
  //       </>
  //     ),
  //   };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      let nextField;
      switch (e.target.id) {
        case "ArticleID":
          nextField = document.getElementById("QtyInput");
          break;
        case "QtyInput":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "PriceWithVAT":
          nextField = document.getElementById("Total");
          break;
        case "PriceWithoutVAT":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "DiscountPercent":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "Total":
          if (showEditForm === true && showInserForm === false) {
            handleSubmitDetailLine(e);
          } else if (showInserForm === true && showEditForm === false) {
            handleNewSubmit(e);
          }
          nextField = document.getElementById("ArticleID");
          break;
        default:
          return;
      }
      if (nextField && nextField.select) {
        nextField.focus();
        nextField.select(); // Shtoni këtë rresht për të selektuar tekstin
      }
    }
  };

  const totalAmount = useMemo(() => {
    return data.reduce(
      (sum, item) =>
        sum + (Number(item.Total) - (Number(item.VAT18) + Number(item.VAT8))),
      0,
    );
  }, [data]);

  const totalVAT = useMemo(() => {
    return data.reduce(
      (sum, item) => sum + Number(item.VAT18) + Number(item.VAT8),
      0,
    );
  }, [data]);

  const grandTotal = useMemo(() => {
    return data.reduce((sum, item) => sum + Number(item.Total), 0);
  }, [data]);

  const rows = data.map((item, index) => ({
    id: ++index,
    inv: item.InvoiceNr,
    date: item.Date.substring(0, 10),
    // client: item.AccountName,
    client: item.ClientBranchID ? item.ClientBranchName : item.AccountName, // Siguro që të mos mbetet bosh
    comment: item.Comment ?? item.Coment ?? "",
    amount: (
      Number(item.Total) -
      (Number(item.VAT18) + Number(item.VAT8))
    ).toFixed(2),
    vat: (Number(item.VAT18) + Number(item.VAT8)).toFixed(2),
    total: item.Total,
    deleteItemId: item.TransactionID, // Shtimi i një atributi për id e rreshtit për fshirje
    rowInfo: item,
  }));

  const detailsRows = detailLine.map((item, index) => ({
    id: ++index,
    article: item.ArticleName,
    qty: item.QtyInput,
    PBD: item.PriceWithoutVATBeforeDiscount,
    discount: item.DiscountPercent,
    PNoVAT: item.PriceWithoutVAT,
    PVAT: item.PriceWithVAT,
    amountNoVAT: item.Amount,
    vat: item.VAT,
    amountVAT: item.Total,
    rowInfo: item,
    deleteItemId: item.HistoryID,
  }));

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleConfirm = () => {
    setShowModal(false);
    setChangeButton(false);
    setShowEditModal(false);
    setShowDetails(true);
  };
  //Kodi ka detyr qe nese lloji i transaksionit eshte eksport ose sherbim jasht vendit, ta vendos VAT 0%
  useEffect(() => {
    if (
      transactionsType == 2 ||
      transactionsType == 3 ||
      transactionsType == 4
    ) {
      setVATRates(0);
    }
  });

  useEffect(() => {
    fetchData();
    fetchClientsDetails(formData.AccountID);
    // fetchArticles();
    // fetchClients();
    fetchCompaniesData();
    fetchArticleDataPrint();
    fetchBanksAccount();
    fetchPaymentType();
  }, [fiscalYear, formData.AccountID, formData.InvoiceNr, articleID]);

  return (
    <div className="AccountingSheet__Container" style={{ paddingTop: "50px" }}>
      <CancelModal
        open={showModal}
        onClose={() => setShowModal(false)}
        title="Konfirmim"
        description="Jeni të sigurt që dëshironi të anuloni ndryshimet?"
        confirmText="po" // Custom confirm button text
        cancelText="jo" // Custom cancel button text
        onConfirm={() => handleConfirm()}
      />
      <Modal
        show={showEmailConfirmation}
        onHide={() => setShowEmailConfirmation(false)}
        style={{ marginTop: "150px" }}
      >
        <Modal.Header>
          <Modal.Title>Konfirmim</Modal.Title>
        </Modal.Header>
        {sendingEmail ? (
          <Modal.Body>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          </Modal.Body>
        ) : (
          <>
            <Modal.Body>
              {clientEmail && clientEmail ? (
                <p>A dëshironi ta dergoni faturën në këtë Email:</p>
              ) : (
                <p>Ju lutem shenoni emailin:</p>
              )}
              <TextField
                required
                style={{ width: "100%" }}
                id="clientEmail"
                label="Email-i i klientit"
                variant="outlined"
                type="text"
                name="clientEmail"
                value={clientEmail}
                onChange={(event) => setClientEmail(event.target.value)}
                autoComplete="off"
              />
              <hr></hr>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "start",
                }}
              >
                <div style={{ paddingTop: "10px" }}>
                  <label>Gjuha e fatures</label>
                </div>
                <div>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Language switcher"
                    style={{
                      display: "flex",
                      // marginRight: '20px', // Adds space between the language buttons and the "Anulo/Dërgo" buttons
                    }}
                  >
                    <Button
                      onClick={() => setLang("sq")}
                      style={{
                        backgroundColor:
                          lang === "sq" ? "#e3f2fd" : "transparent",
                        color: lang === "sq" ? "#1976d2" : "#6b6b6b",
                        borderColor: lang === "sq" ? "#1976d2" : "#d3d3d3",
                        borderRadius: "8px 0 0 8px", // Rounded corner on the left
                        padding: "6px 12px", // Reduced padding to make buttons smaller
                      }}
                    >
                      Shqip
                    </Button>
                    <Button
                      onClick={() => setLang("en")}
                      style={{
                        backgroundColor:
                          lang === "en" ? "#e3f2fd" : "transparent",
                        color: lang === "en" ? "#1976d2" : "#6b6b6b",
                        borderColor: lang === "en" ? "#1976d2" : "#d3d3d3",
                        borderRadius: "0 8px 8px 0", // Rounded corner on the right
                        padding: "6px 12px", // Reduced padding to make buttons smaller
                        marginLeft: "-2px", // Remove the gap between buttons
                      }}
                    >
                      English
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  variant="secondary"
                  onClick={() => setShowEmailConfirmation(false)}
                >
                  Anulo
                </Button>
                <Button
                  variant="danger"
                  onClick={(event) => sendEmail(event, lang)}
                >
                  Dërgo
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>

      {showEditModal && (
        <div className="SalesDetail__Container">
          <TitleElements icon={MdEdit} title="Kthimi i mallit nga klienti" />
          <hr></hr>
          <div className="SalesDetail__Container__AllButtons">
            <div style={{ display: "flex" }}>
              <div>
                <InsertClient type="insert" />
              </div>
              <div style={{ marginLeft: "5px" }}>
                {/* <InsertArticle type="insert" /> */}
                <AddElementsButton
                  text="Krijo Artikull"
                  onClick={() => setIsArticleModalOpen(true)}
                  icon="bi bi-upc-scan"
                  className="button-15"
                />
                <ItemFormModal
                  isOpen={isArticleModalOpen}
                  onClose={() => setIsArticleModalOpen(false)}
                  onSuccess={() => setIsArticleModalOpen(false)}
                  itemToEdit={null}
                />
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ marginLeft: "5px" }}>
                <LinkAndClickButton
                  text="Email"
                  icon={<FaEnvelope />}
                  link="#"
                  onClick={() => {
                    setShowEmailConfirmation(true);
                  }}
                />
              </div>
              <div style={{ marginLeft: "5px" }}>
                {/* <PrintContent details={headerData} companyDetails={companiesData} articleDetails={articlePrintDetails} bankaccounts={bankAccounts} sasia="QtyInput" actiontype="true" link={link} hasElectronicSeal={hasElectronicSeal} /> */}
                <ButtonGroup
                  variant="contained"
                  ref={anchorRef}
                  // aria-label="Button group with a nested menu"
                >
                  <PrintContent
                    details={headerData}
                    companyDetails={companiesData}
                    articleDetails={articlePrintDetails}
                    bankaccounts={bankAccounts}
                    QTY="QtyInput"
                    sasia="fletHyrje"
                    actiontype="true"
                    link={link}
                    hasElectronicSeal={hasElectronicSeal}
                  />
                  <MuiButton
                    style={{
                      width: "30px",
                      height: "35px",
                      marginTop: "10px",
                      borderRadius: "0 5px 5px 0",
                      backgroundColor: "#4E7B67",
                    }}
                    aria-controls={open ? "split-button-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    // aria-label="select print option"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                  >
                    <ArrowDropDownIcon />
                  </MuiButton>
                </ButtonGroup>
                <Popper
                  sx={{ zIndex: 1 }}
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom"
                            ? "center top"
                            : "center bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={hasElectronicSeal} // Lidh me `ElectronicSeal`
                                onChange={(event) =>
                                  setHasElectronicSeal(event.target.checked)
                                } // Përditëson `ElectronicSeal` kur klikohet
                              />
                            }
                            label="Shfaq Vulen Elektronike"
                          />
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>

              <div style={{ display: "flex" }}>
                {changeButton ? (
                  <>
                    <div style={{ marginLeft: "5px" }}>
                      <LinkAndClickButton
                        text="Ruaj"
                        link="#"
                        onClick={handleSubmit}
                      />
                    </div>
                    <div style={{ marginLeft: "5px" }}>
                      <LinkAndClickButton
                        text="Anulo"
                        link="#"
                        onClick={() => {
                          setShowModal(true);
                        }}
                      />
                    </div>
                  </>
                ) : (
                  <div style={{ marginLeft: "5px" }}>
                    <LinkAndClickButton
                      text="Mbyll"
                      link="#"
                      onClick={() => {
                        setShowDetails(true);
                        setShowEditModal(false);
                        setHasClientBranch(false);
                        setClientBranch([]);
                        setClientBranchID("");
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* <div className='header_paper2'></div> */}
          <HeaderPaperComponent />
          <Paper style={{ padding: "20px" }}>
            <form className="header_paper">
              <Box
                // component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1.3, width: "41ch" },
                }}
                noValidate
                autoComplete="off"
              >
                <div className="SalesDetail__Container__Form">
                  <div className="SalesDetail__Container__Form__div">
                    <div className="SalesDetail__Container__Form__div__1">
                      <div className="SalesDetail__Container__Form__div__2">
                        <TextField
                          className="SalesDetail__Container__Form__TextField__1"
                          id="invoiceNR"
                          label="Numri i Fatures"
                          variant="outlined"
                          type="text"
                          name="InvoiceNr"
                          value={formData.InvoiceNr}
                          // value={formData.InvoiceNr}
                          onChange={handleInputChange}
                          disabled
                        />
                        <TextField
                          className="SalesDetail__Container__Form__TextField__1"
                          id="id"
                          select
                          name="TransactionType"
                          label="Lloji Shitjes"
                          value={formData.TransactionType}
                          onChange={(e) => {
                            handleInputChange(e);
                            setTransactionType(e.target.value);
                          }}
                        >
                          {TranscationData.map((data) => (
                            <MenuItem key={data.id} value={data.id}>
                              {data.type}
                            </MenuItem>
                          ))}
                        </TextField>
                        <TextareaAutosize
                          style={{ height: "70px", marginLeft: "10px" }}
                          className="SalesDetail__Container__Form__TextField__1"
                          id="Coment"
                          label="Coment"
                          type="text"
                          name="Coment"
                          value={formData.Coment}
                          onChange={handleInputChange}
                          variant="outlined"
                          autoComplete="off"
                        />
                      </div>
                      <div className="SalesDetail__Container__Form__TextField__date__Payment">
                        <TextField
                          className="SalesDetail__Container__Form__TextField__date"
                          id="date"
                          type="date"
                          variant="outlined"
                          label="Data e Faturës"
                          name="Date"
                          value={formData.Date.substring(0, 10)}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            min: minDate, // Kufizimi minimal i datës
                            max: maxDate, // Kufizimi maksimal i datës
                          }}
                        />
                        <TextField
                          className="SalesDetail__Container__Form__TextField__Payment"
                          id="AccountiD"
                          select
                          label="Mënyra Arkëtimit"
                          name="PaymentOptions"
                          value={formData.PaymentOptions}
                          onChange={handleInputChange}
                          autoComplete="off"
                        >
                          <MenuItem key="0" value="0">
                            Pagesa Behet më vonë
                          </MenuItem>
                          {cashRegister.map((data) => (
                            <MenuItem
                              key={data.AccountID}
                              value={data.AccountID}
                            >
                              {data.AccountName}
                            </MenuItem>
                          ))}
                        </TextField>
                        {formData.PaymentOptions != 0 ? (
                          <TextField
                            className="SalesDetail__Container__Form__TextField__date"
                            id="PayDate"
                            type="date"
                            variant="outlined"
                            label="Data e Pagesës"
                            name="PayDate"
                            value={
                              formData.PayDate
                                ? formData.PayDate.substring(0, 10)
                                : ""
                            }
                            onChange={handleInputChange}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        ) : (
                          <TextField
                            className="SalesDetail__Container__Form__TextField__date"
                            id="PayDate"
                            type="date"
                            variant="outlined"
                            label="Afati i pagesës"
                            name="PayDate"
                            value={
                              formData.PayDate
                                ? formData.PayDate.substring(0, 10)
                                : ""
                            }
                            onChange={handleInputChange}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="SalesDetail__Container__Form__div__4">
                    <div>
                      {/* <Autocomplete
                                                    fullWidth
                                                    // sx={{ m: 2 }}
                                                    {...defaultPropsClients}
                                                    id="AccountID"
                                                    includeInputInList
                                                    onChange={handleAutocompleteChangeClients}
                                                    renderInput={(params) => (
                                                        <TextField {...params}
                                                            label="Klienti"
                                                            // variant="filled"
                                                            className="SalesDetail__Container__Form__TextField__2"
                                                        />
                                                    )}
                                                    value={clients.find(option => option.AccountID === formData.AccountID) || null}
                                                /> */}
                      <AccountsAutocompleteEdit
                        ledgerID={105}
                        // reloadKey={1}
                        accountID={formData.AccountID}
                        labelId="AccountID"
                        onSelect={(account) => {
                          // setShowInventoryAlert(true);
                          // fetchArticleInventory(article.ArticleID);
                          setFormData((prev) => ({
                            ...prev,
                            AccountID: account.AccountID,
                          }));
                          setChangeButton(true);
                        }}
                        onClear={() =>
                          setFormData((prev) => ({
                            ...prev,
                            AccountID: "",
                          }))
                        }
                      />
                    </div>
                    <div style={{ display: "flex" }}>
                      <TextField
                        className="SalesDetail__Container__Form__TextField__IDNumber"
                        // style={{ width: "49%" }}
                        id="outlined-basic"
                        label="Numri Identifikues"
                        variant="outlined"
                        name="IdentificationNumber"
                        value={
                          clientDetails.length > 0
                            ? clientDetails[0].IdentificationNumber
                            : ""
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        readOnly
                        autoComplete="off"
                      />
                      <TextField
                        className="SalesDetail__Container__Form__TextField__IDNumber"
                        // style={{ width: "49%" }}
                        id="outlined-basic"
                        label="Numri i TVSH-së"
                        variant="outlined"
                        name="VatNumber"
                        value={
                          clientDetails.length > 0
                            ? clientDetails[0].VATNumber
                            : ""
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        readOnly
                        autoComplete="off"
                      />
                    </div>
                    {hasClientBranch ? (
                      <div>
                        <Autocomplete
                          fullWidth
                          // sx={{ m: 2 }}
                          {...defaultPropsClientBranch}
                          id="ClientBranchID"
                          includeInputInList
                          onChange={handleAutocompleteChangeClientBranch}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Njesia Klientit"
                              // variant="filled"
                              className="SalesDetail__Container__Form__TextField__2"
                            />
                          )}
                          value={
                            clientBranch.find(
                              (option) =>
                                option.ClientBranchID === clientBranchID,
                            ) || null
                          }
                        />
                      </div>
                    ) : (
                      <div>
                        <TextField
                          className="SalesDetail__Container__Form__TextField__2"
                          // style={{ width: "96%" }}
                          id="outlined-basic"
                          label="Adresa"
                          variant="outlined"
                          name="Address"
                          value={
                            clientDetails.length > 0
                              ? clientDetails[0].Adress
                              : ""
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          readOnly
                          autoComplete="off"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Box>
            </form>
            <div style={{ backgroundColor: "gainsboro " }}>
              <hr></hr>
              {showEditForm && (
                <div className="SalesDetail__Container">
                  <form
                    onSubmit={handleSubmitDetailLine}
                    className="header_paper"
                    onKeyPress={handleKeyPress}
                  >
                    <Box
                      sx={{
                        "& .MuiTextField-root": { m: 1.3, width: "41ch" },
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <div className="SalesDetail__Container__Second__Form">
                        <div
                          className="SalesDetail__Container__Second__Form__Article"
                          style={{ paddingTop: "12px" }}
                        >
                          {/* <Autocomplete
                            fullWidth
                            // sx={{ m: 2 }}
                            {...defaultPropsArticleEdit}
                            id="ArticleID"
                            includeInputInList
                            onChange={handleAutocompleteChangeArticleEdit}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Artikulli"
                                // variant="filled"
                              />
                            )}
                            ListboxProps={{
                              style: {
                                maxHeight: "250px", // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                overflow: "auto", // Aktivizoni scroll-in për pjesën tjetër
                              },
                            }}
                            value={
                              articles.find(
                                (option) =>
                                  option.ArticleID === formDetailData.ArticleID,
                              ) || null
                            }
                          /> */}
                          <ArticleAutocompleteEdit
                            articleId={formDetailData.ArticleID}
                            labelId="ArticleID"
                            priceType="sales"
                            onSelect={(article) => {
                              setFormDetailData((prev) => ({
                                ...prev,
                                ArticleID: article.ArticleID,
                              }));
                              fetchArticlesSalesPrice(
                                article.ArticleID,
                                "edit",
                              );
                            }}
                            onClear={() =>
                              setFormDetailData((prev) => ({
                                ...prev,
                                ArticleID: "",
                              }))
                            }
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details__OtherInputs">
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              type="text"
                              id="QtyInput"
                              name="QtyInput"
                              label="Sasia Hyrje"
                              variant="outlined"
                              autoComplete="off"
                              value={formDetailData.QtyInput}
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithoutVAT("edit")
                              }
                              // onKeyUp={handleCalculatePriceWithoutVATEdit}
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="DiscountPercent"
                              type="text"
                              variant="outlined"
                              label="Rabati %"
                              name="DiscountPercent"
                              autoComplete="off"
                              value={
                                typeof formDetailData.DiscountPercent ===
                                "number"
                                  ? formDetailData.DiscountPercent.toFixed(2)
                                  : formDetailData.DiscountPercent
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithRabat("edit")
                              } // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="PriceWithoutVAT"
                              type="text"
                              variant="outlined"
                              label="Price Without VAT"
                              name="PriceWithoutVAT"
                              autoComplete="off"
                              value={
                                typeof formDetailData.PriceWithoutVAT ===
                                "number"
                                  ? formDetailData.PriceWithoutVAT.toFixed(4)
                                  : formDetailData.PriceWithoutVAT
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithVAT("edit")
                              }
                              // disabled={form2IsDisabled}
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="PriceWithVAT"
                              type="text"
                              variant="outlined"
                              label="Price With VAT"
                              name="PriceWithVAT"
                              autoComplete="off"
                              value={
                                typeof formDetailData.PriceWithVAT === "number"
                                  ? formDetailData.PriceWithVAT.toFixed(4)
                                  : formDetailData.PriceWithVAT
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithoutVAT("edit")
                              }
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="Total"
                              label="Total"
                              variant="outlined"
                              // name='Amount'
                              name="Total"
                              autoComplete="off"
                              value={
                                typeof formDetailData.Total === "number"
                                  ? formDetailData.Total.toFixed(2)
                                  : formDetailData.Total
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() => handleCalculatePrices("edit")}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>

                          <div className="butonat">
                            <div>
                              <Button
                                type="submit"
                                variant="success"
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-check-lg"></i>
                              </Button>
                            </div>
                            <div>
                              <Button
                                variant="danger"
                                onClick={clearEdit}
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-x-lg"></i>
                              </Button>
                            </div>
                          </div>

                          <div className="responsive">
                            <div className="responsive__butonat">
                              <div>
                                <Button
                                  type="submit"
                                  variant="success"
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-check-lg"></i>
                                </Button>
                              </div>
                              <div>
                                <Button
                                  variant="danger"
                                  onClick={clearEdit}
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-x-lg"></i>
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Box>
                  </form>
                </div>
              )}
              {showInserForm && (
                <div className="SalesDetail__Container">
                  <form
                    onSubmit={handleNewSubmit}
                    className="header_paper"
                    onKeyPress={handleKeyPress}
                  >
                    <Box
                      // component="form"
                      sx={{
                        "& .MuiTextField-root": { m: 1.3, width: "41ch" },
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <div className="SalesDetail__Container__Second__Form">
                        <div
                          className="SalesDetail__Container__Second__Form__Article"
                          style={{ paddingTop: "12px" }}
                        >
                          {/* <Autocomplete
                            fullWidth
                            {...defaultPropsArticle}
                            id="ArticleID"
                            includeInputInList
                            value={field}
                            onChange={handleAutocompleteChangeArticle}
                            isOptionEqualToValue={(option, value) =>
                              option.ArticleID === value.ArticleID
                            } // Shto funksionin isOptionEqualToValue
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Kerko Artikullin"
                                // variant="filled"
                                // onKeyPress={handleKeyPress}
                              />
                            )}
                            ListboxProps={{
                              style: {
                                maxHeight: "250px", // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                overflow: "auto", // Aktivizoni scroll-in për pjesën tjetër
                              },
                            }}
                          /> */}
                          <ArticleAutocompleteInsert
                            value={field}
                            priceType="sales"
                            label="Kerko Artikullin"
                            onSelect={(article) => {
                              setArticleID(article.ArticleID);
                              fetchArticlesSalesPrice(article.ArticleID);
                              setField(article);
                            }}
                            onClear={() => {
                              setArticleID("");
                              setField(null);
                            }}
                            labelId="ArticleID"
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details__OtherInputs">
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="QtyInput"
                              type="text"
                              variant="outlined"
                              label="Sasia Hyrje"
                              name="QtyInput"
                              autoComplete="off"
                              value={qtyInput}
                              onChange={(e) => setQtyInput(e.target.value)}
                              onKeyUp={handleCalculatePriceWithoutVAT} // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="DiscountPercent"
                              type="text"
                              variant="outlined"
                              label="Rabati %"
                              name="DiscountPercent"
                              autoComplete="off"
                              value={
                                typeof discountPercent === "number"
                                  ? discountPercent.toFixed(2)
                                  : discountPercent
                              }
                              onChange={(e) =>
                                setDiscountPercent(e.target.value)
                              }
                              onKeyUp={handleCalculatePriceWithRabat} // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="PriceWithoutVAT"
                              type="text"
                              variant="outlined"
                              label="Cmimi pa TVSH"
                              name="PriceWithoutVAT"
                              autoComplete="off"
                              value={
                                typeof insertpriceWithoutVAT === "number"
                                  ? insertpriceWithoutVAT.toFixed(4)
                                  : insertpriceWithoutVAT
                              }
                              onChange={(e) =>
                                setInsertPriceWithoutVAT(e.target.value)
                              }
                              onKeyUp={handleCalculatePriceWithVAT}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="PriceWithVAT"
                              type="text"
                              variant="outlined"
                              label="Cmimi me TVSH"
                              name="PriceWithVAT"
                              autoComplete="off"
                              value={
                                typeof insertPriceWithVAT === "number"
                                  ? insertPriceWithVAT.toFixed(4)
                                  : insertPriceWithVAT
                              }
                              onChange={(e) =>
                                setInsertPriceWithVAT(e.target.value)
                              }
                              onKeyUp={handleCalculatePriceWithoutVAT} // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="Total"
                              label="Total"
                              variant="outlined"
                              name="Total"
                              autoComplete="off"
                              value={
                                typeof insertTotal === "number"
                                  ? insertTotal.toFixed(2)
                                  : insertTotal
                              }
                              onChange={(event) =>
                                setInsertTotal(event.target.value)
                              }
                              onKeyUp={handleCalculatePrices}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>
                          <div className="butonat">
                            <div>
                              <Button
                                type="submit"
                                variant="success"
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-plus-lg"></i>
                              </Button>
                            </div>
                            <div>
                              <Button
                                variant="danger"
                                onClick={clearLine}
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-x-lg"></i>
                              </Button>
                            </div>
                          </div>

                          <div className="responsive">
                            <div className="responsive__butonat">
                              <div>
                                <Button
                                  type="submit"
                                  variant="success"
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-plus-lg"></i>
                                </Button>
                              </div>
                              <div>
                                <Button
                                  variant="danger"
                                  onClick={clearLine}
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-x-lg"></i>
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Box>
                  </form>
                </div>
              )}
              <DataGridWithActions
                columns={detailsData}
                rows={detailsRows}
                handleEdit={handleEditDetails}
                handleDelete={handleDeleteDetailLine}
                showPayment={false}
              />
            </div>
            <br></br>
            <div className="responsive__Tablet">
              <div className="SalesDetail__Container__Form">
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Amount18"
                    // style={{ width: "100%" }}
                    id="Amount18"
                    label="Vlera 18"
                    variant="outlined"
                    type="text"
                    name="Amount18"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Amount18.toFixed(2)
                        : ""
                    }
                    disabled
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VAT18"
                    // style={{ width: "100%" }}
                    id="VAT18"
                    label="TVSH 18"
                    variant="outlined"
                    type="text"
                    name="VAT18"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].VAT18.toFixed(2)
                        : ""
                    }
                    disabled
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Amount8"
                    // style={{ width: "100%" }}
                    id="Amount8"
                    label="Vlera 8"
                    variant="outlined"
                    type="text"
                    name="Amount8"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Amount8.toFixed(2)
                        : ""
                    }
                    disabled
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VAT8"
                    // style={{ width: "100%" }}
                    id="VAT8"
                    label="TVSH 8"
                    variant="outlined"
                    type="text"
                    name="VAT8"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].VAT8.toFixed(2)
                        : ""
                    }
                    disabled
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Amount0"
                    // style={{ width: "100%" }}
                    id="Amount0"
                    label="Vlera 0"
                    variant="outlined"
                    type="text"
                    name="Amount0"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Amount0.toFixed(2)
                        : ""
                    }
                    disabled
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VAT0"
                    // style={{ width: "100%" }}
                    id="VAT0"
                    label="TVSH 0"
                    variant="outlined"
                    type="text"
                    name="VAT0"
                    value={valuedetails.length > 0 ? 0 : ""}
                    disabled
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    style={{ width: "81%" }}
                    id="DiscountAmount"
                    label="Zbritja në vlerë"
                    variant="outlined"
                    type="text"
                    name="DiscountAmount"
                    value={discountAmount}
                    onChange={(e) => {
                      setDiscountAmount(e.target.value);
                      calculatePercent(e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Apliko Zbritjen" placement="right">
                            <IconButton
                              type="submit"
                              onClick={constUpdateDiscountAmount}
                            >
                              <i
                                class="bi bi-check-lg"
                                style={{ color: "green" }}
                              ></i>
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__TotalAmount"
                    id="TotalAmount"
                    label="Total pa TVSH"
                    variant="outlined"
                    type="text"
                    name="TotalAmount"
                    value={
                      valuedetails.length > 0
                        ? (
                            valuedetails[0].Amount18 +
                            valuedetails[0].Amount8 +
                            valuedetails[0].Amount0
                          ).toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VATTotal"
                    // style={{ width: "100%" }}
                    id="VATTotal"
                    label="Total TVSH"
                    variant="outlined"
                    type="text"
                    name="VATTotal"
                    value={
                      valuedetails.length > 0
                        ? (
                            valuedetails[0].Total -
                            (valuedetails[0].Amount18 +
                              valuedetails[0].Amount8 +
                              valuedetails[0].Amount0)
                          ).toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Total"
                    // style={{ width: "100%" }}
                    id="Totali"
                    label="Për pagesë"
                    variant="outlined"
                    type="text"
                    name="Totali"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Total.toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                </div>
                <br></br>
              </div>
            </div>
          </Paper>
        </div>
      )}
      {showDetails && (
        <div className="shfaqePermbajtjen">
          <div className="header_flex">
            <TitleElements
              icon={AiFillAppstore}
              title="Lista e kthimit të mallit nga klienti"
            />
            <AddLinkButton
              text="Krijo faturë"
              icon="bi bi-plus-circle"
              link="/Sales/newReturnFromCustomer"
            />
          </div>
          <ElementsParagraph text="Forma e kthimit të mallit nga klienti: Menaxhoni, shtoni, editoni dhe fshini Fatura." />

          <DataGridWithActions
            columns={returnGridHeader}
            rows={rows}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            showPayment={true}
            height={500}
          />

          <TotalSummaryComponent
            fields={[
              { id: "1", label: "Vlera", value: totalAmount },
              { id: "2", label: "TVSH", value: totalVAT },
              { id: "3", label: "Total", value: grandTotal },
            ]}
          />
        </div>
      )}
    </div>
  );
}
